import React, { useEffect, useState } from 'react'
import { TabMenu } from 'primereact/tabmenu';
import { Button } from 'primereact/button'
import { useIntl } from 'react-intl'
import { HeaderView } from 'medere-ui-framework';
//import { useLocation } from 'react-router';
import { ManagerGeneralDataDTO, initialStateManager } from '../../interface/ManagerType';
import ManagerGeneralDataPanel from './Tabs/ManagerGeneralDataPanel';
import ManagerFiscalData from './Tabs/ManagerFiscalData';
import ManagerHealthEntity from './Tabs/ManagerHealthEntity';
import EntityContacts from '../Contacts/EntityContacts';
import { useContactsService } from '../../servicesHooks/Contacts/useContactsService';
import { useManagerService } from '../../servicesHooks/Manager/useManagerService';


interface ManagerCrudPanelDataProps {
    medereentity: number;
    setMedereentity: (medereentity: number|null) => void;

}

export default function ManagerCrudPanel({ medereentity, setMedereentity }: Readonly<ManagerCrudPanelDataProps>) {
  
  //const location = useLocation();
  const intl = useIntl();
  const { getProfessionalContactsTypes } = useContactsService();
  const { getManagerGeneralData } = useManagerService();
  const [manager, setManager] = useState<ManagerGeneralDataDTO>(initialStateManager);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {//aca es donde le paso el selectedMedereentity desde ManagerList (agregar parametro al componente)
    /*location.state?.medereentity*/medereentity && getManagerGeneralData(/*location.state.medereentity*/medereentity).then((res: any) => {
      let data: ManagerGeneralDataDTO = res;
      setHeaderView(data.medereentity && data.medereentity > 0 ? data.commercialname : '')
      setManager(data);
    })
  }, [])

  const items = [
    { label: "Datos generales", icon: 'pi pi-fw pi-home' },
    { label: "Contactos", icon: 'pi pi-users', disabled: manager.medereentity === null || manager.medereentity < 0},
    { label: "Datos Fiscales", icon: 'pi pi-fw pi-calendar', disabled: manager.medereentity === null || manager.medereentity < 0  },
    { label: "Obras Sociales", icon: 'pi pi-fw pi-calendar',  disabled: manager.medereentity === null || manager.medereentity < 0   }
  ];

  let componentToDisplay = null;

  const [headerView, setHeaderView] = useState('')
  switch (activeIndex) {
    case 0:
      componentToDisplay = <ManagerGeneralDataPanel setHeaderView={setHeaderView} manager={manager} setManager={setManager} />
      break;
    case 1:
      componentToDisplay = <EntityContacts entityid={manager.medereentity ?? -1} getContactsTypes={getProfessionalContactsTypes} />
      break;
    case 2:
      componentToDisplay = <ManagerFiscalData medereentity={manager.medereentity ?? -1} setBusinessname={setHeaderView} setMedereentity={setMedereentity}/>
      break;
    case 3:
      componentToDisplay = <ManagerHealthEntity medereentity={manager.medereentity ?? -1} />
      break;

    default: break;
  }


  return (
    <React.Fragment>
      <div className='h-full'>
      <Button className='btnCancel' label={'<<'+intl.formatMessage({ id: "Back" })} onClick={() => setMedereentity(null)} />
      <HeaderView divider title={"Gerenciadora"} subTitle={headerView}></HeaderView>
      <TabMenu className='ml-3.5 mb-3' model={items} activeIndex={activeIndex} onTabChange={(e: any) => { setActiveIndex(e.index) }} />
      {componentToDisplay}
      </div>
    </React.Fragment>
  )

}
